/**
 * Tooltip component - touchscreen-friendly
 * Shows tooltip on click/tap instead of hover
 */

// Close all active tooltips
function closeAllTooltips() {
  document.querySelectorAll('.tooltip-trigger.active').forEach(trigger => {
    trigger.classList.remove('active');
  });
}

// Initialize tooltips
function initTooltips() {
  const triggers = document.querySelectorAll('.tooltip-trigger');

  triggers.forEach(trigger => {
    // Handle click/tap
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const isActive = this.classList.contains('active');

      // Close all other tooltips
      closeAllTooltips();

      // Toggle this tooltip
      if (!isActive) {
        this.classList.add('active');
      }
    });

    // Prevent image drag on tooltip icons
    const img = trigger.querySelector('img');
    if (img) {
      img.addEventListener('dragstart', function(e) {
        e.preventDefault();
      });
    }
  });

  // Close tooltips when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.tooltip-trigger')) {
      closeAllTooltips();
    }
  });

  // Close tooltips on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllTooltips();
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTooltips);
} else {
  initTooltips();
}

// Re-initialize when content is dynamically loaded (for AJAX/snippets)
document.addEventListener('contentLoaded', initTooltips);

export { initTooltips, closeAllTooltips };
